<template>
  <sAlert
    v-if="value.length"
    small>
    {{ $t('Tenders.BidType.isPublic') }}
    <ul slot="desc">
      <li
        v-for="(itemParametr, itemIndex) in value"
        :key="`item-${itemIndex}`">
        {{ itemParametr.key }} {{ itemParametr.value }}
      </li>
    </ul>
  </sAlert>
</template>
<script>
export default {
  name: 'EventHistoryAddedNewAdditionalCategoriesParams',
  props: {
    value: {
      type: Array
    }
  },
}
</script>